export default __webpack_public_path__ + "static/media/test-tube.cf3556b9.png";